import request from '@/utils/requestPC'
import axios from 'axios'
export function getMatchCategory(data: Record<string, any>) {
    return request({
        url: '/admin-api/match_category',
        method: 'get',
    })
}

export function uploadImage(data: Record<string, any>) {
    return request({
        url: '/api/upload',
        method: 'post',
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        data
    })
}
export function createMatch(data: Record<string, any>) {
    return request({
        url: '/admin-api/create',
        method: 'post',
        data
    })
}
export function businessApply(data: Record<string, any>) {
    return request({
        url: '/admin-api/business_apply',
        method: 'post',
        data
    })
}

export function getDesignerApplyDict(data: Record<string, any>) {
    return request({
        url: '/api/public/business_dict',
        method: 'get',
        params: data
    })
}
export function shareQrcode(data: Record<string, any>) {
    return request({
        url: '/admin-api/share_qrcode',
        method: 'post',
        data
    })
}
export function checkRole(data: Record<string, any>) {
    return request({
        url: '/admin-api/check_role',
        method: 'get',
        params: data
    })
}
export function getBusinessApplyStatus(params: Record<string, any>) {
    return request({
        url: '/admin-api/business_apply_status',
        method: 'get',
        params
    })
}
export function getBusinessDetail(data: Record<string, any>) {
    return request({
        url: '/admin-api/business_apply_detail',
        method: 'post',
        data
    })
}
export function editBusinessDetail(data: Record<string, any>) {
    return request({
        url: '/admin-api/business_again_apply',
        method: 'post',
        data
    })
}